import { getLLMModel } from "./index";
import { HumanMessage, SystemMessage } from "@langchain/core/messages";

export async function callLLM(prompt: string, promptInput: any) {
  console.log({
    promptInput,
  });
  // console.log(promptInput);
  let llmModel = getLLMModel();
  const messages = [new SystemMessage(prompt), new HumanMessage(JSON.stringify(promptInput))];
  let retryCount = 0;
  const llmApiCall: any = async () => {
    try {
      const result = await llmModel.invoke(messages);
      // console.log(result?.content);
      return result.content;
    } catch (error: any) {
      console.log(error);
      if (retryCount < 3) {
        retryCount++;
        // console.log("Retrying the request");
        return llmApiCall();
      }
      throw new Error("Failed to generate the response from the AI model");
    }
  };
  return llmApiCall();
}

export async function callBedRockLLM(prompt: string, promptInput: any) {
  // console.log({
  //   promptInput,
  // });
  let llmModel = getLLMModel("bedrock");
  const messages = [
    new SystemMessage(`Provide your final crafted translated comment in this JSON object format onlyin the same "message" key:
{
"message": "Your single-sentence comment here in the translated language",
"scratchpad": "scratchpad response"
}

Note: Don't write anything else apart from the response in JSON format.
`),
    new HumanMessage(`${prompt}\\n\\n User Input: ${JSON.stringify(promptInput)}`),
  ];
  let retryCount = 0;
  const llmApiCall: any = async () => {
    try {
      const result = await llmModel.invoke(messages);
      return result.content;
    } catch (error: any) {
      console.log(error);
      if (retryCount < 3) {
        retryCount++;
        // console.log("Retrying the request");
        return llmApiCall();
      }
      throw new Error("Failed to generate the response from the AI model");
    }
  };
  return llmApiCall();
}
